export const categories = [
	{
		id: 1,
		isLink: true,
		isHeader: true,
		link: '/libraries',
		title: 'EBC libraries'
	},
	{
		id: 2,
		isLink: false,
		isHeader: true,
		title: 'Products',
	},
	{
		id: 3,
		isLink: true,
		isHeader: true,
		link: '/impurities',
		title: 'Drugs & Impurities'
	},
	{
		id: 4,
		isLink: true,
		isHeader: true,
		link: '/chemical-probes',
		title: 'Chemical probes'
	},
	{
		id: 5,
		isLink: true,
		isHeader: true,
		title: 'Services',
		link: '/services'
	},
	{
		id: 6,
		isLink: true,
		isHeader: true,
		title: 'Search',
		link: '/search?tab=text-search'
	},
	{
		id: 7,
		isLink: true,
		isHeader: false,
		title: 'Terms of Service',
		link: '/terms-of-service'
	},
	{
		id: 8,
		isLink: true,
		isHeader: false,
		title: 'Privacy Policy',
		link: '/privacy-policy'
	},
	{
		id: 9,
		isLink: true,
		isHeader: false,
		isRedirect: true,
		title: 'Publications',
		link: 'https://enamine.net/publications'
	},
	{
		id: 10,
		isLink: true,
		isHeader: false,
		title: 'Contact us',
		link: '/contact-us'
	},
	{
		id: 11,
		isLink: true,
		isHeader: false,
		title: 'About us',
		link: '/about-us'
	}
];

export const dropdownMenu = [
	{ label: 'My account', url: '/account', isShow: true },
	{ label: 'My projects', url: '/projects', isShow: true },
	{ label: 'My requests', url: '/request', isShow: false },
	{ label: 'Settings', url: '/settings', isShow: false },
	{ label: 'Logout', url: '', isLogout: true, isShow: true }
];
